import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useCallback, useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { checkDpSuccess, getFormErrorMessage } from "../../utility/service/tool-service";
import { Checkbox } from "primereact/checkbox";
import { FormInputRadio } from "../../components/FormInputRadio";
import { B2010103Before, queryFeFunctionsInfo, updateFeFunctionsInfo } from "../../utility/service/funclist-service";
import { MessageContext,handleSuccessMessage } from "../../store/messageStore";
import { SystemLoading,checkLoading } from "../../store/loadingStore";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import { addFormValidator } from "../../utility/validate/formValidator";
import { useEditableFlag } from "../../hooks/useEditableFlag";

export default function FuncList_Detail(){

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [detailObj,setDetailObj] = useState({});
    const [, dispatch] = useContext(MessageContext); //訊息視窗
    const [,loading] = useContext(SystemLoading);  
    const [editAction,setEditAction] = useState('detail');//設定目前的動作
    const [enableList,setEnableList] = useState([]);
    const [formRule, setFormRule] = useState([]); //表單驗證
    const isEditable = useEditableFlag('B20101');
    const useTypeList = [
        {
            label:t('company.a'),value:"A"
        },
        {
            label:t('company.b'),value:"B"
        },
        {
            label:t('company.m'),value:"M"
        }
    ]

    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
            name:'',
            useTypes: []
        },
        //錯誤驗證時機
        mode: "all"
      });

    const formValues = watch('useTypes');
    // Ensure formValues is an array
    const normalizedFormValues = Array.isArray(formValues) ? formValues : [];

    const btnBackTo = ()=>{
        navigate("/management/funcList");
    }

    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }

    const onSubmit = (data) => {
       let reqBody = {
        funcId:detailObj?.funcId,
        name:data.name,
        funcOrder:parseInt(data.funcOrder),
        enable:data.enable,
        useTypes:data.useTypes?.join('|'),
        enUs:data.enUs,
        vi:data.vi
       }
       axios_updateFeFunctionsInfo(reqBody);
       
      }

    const axios_updateFeFunctionsInfo = (reqBody)=>{
        updateFeFunctionsInfo(reqBody)
            .then((res)=>{
                if(checkDpSuccess(res)){
                    handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
                    btnBackTo();
                }
            })
    }  

    const axios_getCreateBefore = ()=>{
        B2010103Before()
          .then((res)=>{
              if(checkDpSuccess(res)){
                  let array = []
                  res?.data?.RespBody?.constraints?.forEach((item) => {
                      const result = addFormValidator(item?.field, res.data.RespBody.constraints);
                      array.push(result)
                  })
                  setFormRule(array);
              }
          })
    }

    const setValidForm = useCallback((formId) => {
        if (formRule?.length > 0) {
            const tmp = formRule?.find((item) => {
                return Object.keys(item)[0] === formId
            });
            return tmp ? tmp[formId] : '';
        }
    }, [formRule]);

    useEffect(()=>{
        if((action)!==''){
            axios_getCreateBefore();
            axios_getEnableStatusList();
            setEditAction(action);
            axios_queryNoticeRecordsInfo();
        }else{
            btnBackTo();
        }
    },[action])

    const axios_queryNoticeRecordsInfo = ()=>{
        checkLoading(loading);
        queryFeFunctionsInfo({funcId:itemObj?.funcId})
            .then((res)=>{
                let data = res?.data?.RespBody;
                setDetailObj(data);
                setValue("useTypes",data?.useTypes?.split("|"), { shouldValidate: true });
                setValue("funcId",data?.funcId, { shouldValidate: true });
                setValue("name",data?.name, { shouldValidate: true });
                setValue("funcOrder",data?.funcOrder, { shouldValidate: true });
                setValue("enable",data.enable, { shouldValidate: true });
                setValue("enUs",data.enUs, { shouldValidate: true });
                setValue("vi",data.vi, { shouldValidate: true })
                clearErrors();

            }).finally((fin)=>{checkLoading(loading,false);})
    }

    const handleCheckboxChange = (itemValue, checked) => {
        const updatedValues = checked
          ? [...normalizedFormValues, itemValue] // Add the value if checked
          : normalizedFormValues?.filter(value => value !== itemValue); // Remove the value if unchecked
    
        setValue('useTypes', updatedValues, { shouldValidate: true }); // Update form value
      };

    const axios_getEnableStatusList = ()=>{
        getSubItemsByItemNo('ENABLE_STATUS',18)
        .then((res)=>{
            if(checkDpSuccess(res)){
                let data = res.data.RespBody.subItems;
                let newArray = data.map((item, index) => {
                  return {
                    ...item,
                    index: index,
                  }
                })
                setEnableList(newArray);
            }
        })
    }  

    return (
    <>
    {/* 返回上頁 */}
    <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
            <Button rounded text onClick={() => { btnBackTo(); }}>
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t('button.return_to_list')}
            </Button>
        </div>
    </div>
    <div className="p-card">
        <div className="p-card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid">
                {/*功能代號*/}
                <div className='col-12 lg:col-3'>
                    <label
                        className="form-label">
                        {t("funcId")}
                    </label>
                    <span>{detailObj?.funcId}</span>
                </div>
                {/*功能群組*/}
                <div className='col-12 lg:col-3'>
                    <label
                        className="form-label">
                        {t("groupId")}
                    </label>
                    <span>{detailObj?.groupId}</span>
                </div>
                {/* 父層代號 */}
                <div className='col-12 lg:col-3'>
                    <label
                        className="form-label">
                        {t("parentId")}
                    </label>
                    <span>{detailObj?.parentId}</span>
                </div>
                {/* 狀態 */}
                <div className='col-12 lg:col-3'>
                    <label
                        htmlFor="enable"
                        className={`form-label ${editAction !== 'detail' ? 'required' : ''}`}>
                        {t("status")}
                    </label>
                <Controller
                    name="enable"
                    control={control}
                    rules={setValidForm('enable')}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            disabled={editAction==='detail' || !isEditable}
                            filter
                            optionLabel="subitemName"
                            optionValue="subitemNo"
                            value={field.value}
                            virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="enable"
                            control={control}
                            options={enableList}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )}
                />
                {getFormErrorMessage(errors, "enable")}

                </div>
            </div>
            <div className="grid my-1">
                <div className="col-12 lg:col-3">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="name"
                        type="text"
                        placeholder={`${t('fun_name')}(zh-tw)`}
                        labelClass={`control-label ${editAction !== "detail" ? 'required' : ''}`}
                        enterClick={checkKeyDown}
                        labelText={`${t('fun_name')}(zh-tw)`}
                        disabled={editAction==='detail' || !isEditable}
                        rules={setValidForm("name")}
                    />
                </div>
                <div className="col-12 lg:col-3">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="enUs"
                        type="text"
                        placeholder={`${t('fun_name')}(en-US)`}
                        labelClass={`control-label ${editAction !== "detail" ? 'required' : ''}`}
                        enterClick={checkKeyDown}
                        labelText={`${t('fun_name')}(en-US)`}
                        disabled={editAction==='detail' || !isEditable}
                        rules={setValidForm("enUs")}
                        
                    />
                </div>
                <div className="col-12 lg:col-3">
                    <FormInput
                        register={register}
                        errors={errors}
                        id="vi"
                        type="text"
                        placeholder={`${t('fun_name')}(vi)`}
                        labelClass={`control-label ${editAction !== "detail" ? 'required' : ''}`}
                        enterClick={checkKeyDown}
                        labelText={`${t('fun_name')}(vi)`}
                        disabled={editAction==='detail' || !isEditable}
                        rules={setValidForm("vi")}
                        
                    />
                </div>
            </div>           
            <div className="grid my-1">
            {/* 身分別 useTypes  */}
            <div className="col-12 lg:col-6">
                <label
                    htmlFor="useTypes"
                    className={`form-label ${editAction!=='detail' ? 'required' : ''}`}>
                    {t("authorizedIdentity")}
                </label> 
                {/* {
                useTypeList?.map((item,key) => {
                  return (
                    <div key={key} className="flex" style={{margin:'-1px'}}>
                      <FormInputRadio
                        type="checkbox"
                        register={register}
                        errors={errors}
                        id={`useType` + key}
                        labelText={item.label}
                        name="useType"
                        value={item.value}
                      />
                    </div>

                  )
                })
              } */}
              <div className="flex flex-wrap gap-1">
              {
                useTypeList?.map((item)=>{
                    return(<Controller
                        key={item?.value}
                        name="useTypes"
                        control={control}
                        rules={setValidForm("useTypes")}
                        render={({ field, fieldState }) => (
                            <>
                            <div key={item.value}>
                                    <Checkbox disabled={editAction==='detail' || !isEditable} inputId={item.value} checked={normalizedFormValues?.includes(item?.value)}  className={classNames({ 'p-invalid': fieldState.error })} onChange={(e) => {
                                    handleCheckboxChange(item.value, e.checked);
                                    }} />
                                <label htmlFor={item.value} className="ml-2">{item?.label}</label>
                            
                            </div>
                            </>
                        )}
                    />)
                })
              }

              </div>
              {getFormErrorMessage(errors, "useTypes")}

            
                
            </div>
            <div className="col-12 lg:col-6">
                {/* 排序 */}
                <FormInput
                        register={register}
                        errors={errors}
                        id="funcOrder"
                        type="number"
                        placeholder={t('order')}
                        labelClass={`control-label ${editAction !== "detail" ? 'required' : ''}`}
                        enterClick={checkKeyDown}
                        labelText={t('order')}
                        disabled={editAction==='detail' || !isEditable}
                        rules={{required: { value: true, message: t('validation.required') }}}
                    />
            </div>
               
            </div>
            <div className="grid">
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("create_user")}
                    </label>
                    <span>{detailObj?.createUser}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("create_date")}
                    </label>
                    <span>{detailObj?.createDateTime}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("update_user")}
                    </label>
                    <span>{detailObj?.updateUser}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("update_date")}
                    </label>
                    <span>{detailObj?.updateDateTime}</span>
                </div>
            </div>
            <div className="col-12 gap-2 flex-all-center">
              {
                ( editAction === 'detail') ?( <div className="col-12 gap-2 flex-all-center">
                    <Button disabled={!isEditable} label={t("button.edit")} onClick={(e) => {
                        e.preventDefault();
                        setEditAction('update');
                    }} type="button" size="small" />
                </div>):(<>
                    <Button disabled={!isValid || !isEditable} type="submit" label={t("button.confirm")} size="small" />
                    <Button outlined size="small" type="button" label={t("button.cancel")} onClick={(e) => {
                         btnBackTo();
                    }} />
                </>)
              }
            </div>
            </form>
          
        </div>
    </div>
    </>
    )
}